// Player select and character helpers
import { GFX } from '../core/graphics';
import { SFX } from '../core/audio';
import { $ } from './dom';
import { I } from './icons';
import { Store, type Profile } from '../core/store';
import { t } from '../core/i18n';
import { openCreator } from './creator';
import { openMap } from './map';

// Character helpers
/** A player's character: animal and colours of shirt and shoes */
export interface Character { animal: string; shirt: string; shoes: string }
const DEF_CH: Character = { animal: 'frog', shirt: '#4A90E2', shoes: '#E94B4B' };
export const chOf = (p: Profile): Character => p.ch || DEF_CH;
export function headImg(ch: Pick<Character, 'animal'>, size: number) {
  const c = document.createElement('canvas'); c.width = c.height = size * 2;
  const x = c.getContext('2d')!; x.scale(2, 2); GFX.head(x, ch.animal, size / 2, size * 0.58, size * 0.33);
  return `<img src="${c.toDataURL()}" width="${size}" height="${size}" alt="">`;
}
function charCanvas(ch: Character, w: number, h: number) {
  const c = document.createElement('canvas'); c.width = w * 2; c.height = h * 2; c.style.width = w + 'px'; c.style.height = h + 'px';
  const x = c.getContext('2d')!; x.scale(2, 2); GFX.char(x, ch, w / 2, h - 8, h - 16);
  return c;
}

export function renderProfiles() {
  const box = $('#profiles'); box.innerHTML = '';
  for (let i = 0; i < 4; i++) {
    const p = Store.d.profiles[i];
    const b = document.createElement('button');
    if (p) {
      const st = Object.values(p.prog).reduce((a, v) => a + v.stars, 0);
      b.className = 'pcard';
      b.appendChild(charCanvas(chOf(p), 130, 170));
      const s = document.createElement('div'); s.className = 'pst'; s.innerHTML = `${I.star}<span>${st}</span>`; b.appendChild(s);
      const ed = document.createElement('span'); ed.className = 'edit'; ed.innerHTML = I.brush; ed.setAttribute('aria-label', t('aria.changeClothes'));
      ed.addEventListener('click', e => { e.stopPropagation(); SFX.play('click'); openCreator(p); });
      b.appendChild(ed);
      b.setAttribute('aria-label', t('aria.player', { n: i + 1 }));
      b.addEventListener('click', () => { SFX.play('click'); Store.d.cur = p.id; Store.save(); openMap(); });
    } else {
      b.className = 'pcard add'; b.innerHTML = I.plus; b.setAttribute('aria-label', t('aria.newPlayer'));
      b.addEventListener('click', () => { SFX.play('click'); openCreator(null); });
    }
    box.appendChild(b);
  }
}
